/**
 * Selected work, newest first. Kept here so the home page and any future
 * project page read from one list.
 */
const work = [
  {
    title: 'BuniAI',
    role: 'Co-founder',
    period: '2024 —',
    summary:
      'A collaborative canvas that turns business requirements into production USSD and chatbot workflows. Cut build cycles from weeks to days.',
    stack: ['React', 'TypeScript', 'Node', 'LLMs'],
    href: 'https://buniai.com',
  },
  {
    title: 'Tupande Mobile',
    role: 'Lead',
    period: '2022 —',
    summary:
      'Award-winning commerce app for smallholder farmers. Offline-first, syncs when a signal returns, serving thousands of farms across Africa.',
    stack: ['React Native', 'Node', 'MongoDB', 'AWS'],
  },
  {
    title: 'USSD Framework',
    role: 'Architect',
    period: '2021 —',
    summary:
      'A plug-and-play engine for shipping configurable USSD services fast. Deployed across multiple countries on the same core.',
    stack: ['Java', 'Node', 'Postgres', 'Redis'],
  },
];

export default work;
